// used to replace clipboard api in secure assignments to avoid cheating warnings.
const LOCAL_CLIPBOARD_KEY = 'local_clipboard';

const localClipboard = {
  writeText: (text) => {
    window.sessionStorage.setItem(LOCAL_CLIPBOARD_KEY, text);
  },
  readText: () => {
    const clipboardText = window.sessionStorage.getItem(LOCAL_CLIPBOARD_KEY);
    return clipboardText;
  },
};

export default localClipboard;
